// extracted by mini-css-extract-plugin
module.exports = {"dropdown-menu":"dropdown_dropdown-menu__3mo2C","dropdown-menu-item":"dropdown_dropdown-menu-item__px9Ck"};